import {gql} from "@apollo/client";

export const POD_IMAGE_UPDATE = gql`
    mutation PodImageUpdate($input: PodImageUpdateInput!) {
        podImageUpdate(input: $input) {
            success
            errorCode
            message
            trackingNumber
        }
    }
`;

export interface PodImageUpdateInput {
    warehouseId?: string | null;
    trackingNumber: string;
    podUpdateImageList: string[];
}

export interface OperationResultType {
    success: boolean;
    errorCode?: string;
    message?: string;
    trackingNumber?: string;
}

export interface PodImageUpdateResponse {
    podImageUpdate: OperationResultType;
}
